import axios from '@/helpers/_core/axios';
import CONST from '@/helpers/_core/const';

export default class User {
  static SERVICE_NAME = 'user';

  constructor({ app }) {
    this.axios = axios(app);
    this.state = app.store.state._core;
    this.getters = app.store.getters;
  }

  /* ========== Recover Username ========== */
  recoverUsername(body) {
    if (this.getters['_core/auth/isRoleOperation']) {
      return this.recoverUsernameOperationApplication(body, this.state.application.alias);
    }

    return this.recoverUsernameApplication(body, this.state.auth.currentRole?.tenant?.alias || this.state.tenant.alias, this.state.application.alias);
  }

  recoverUsernameOperationApplication(body, applicationAlias) {
    const { captcha } = body;
    delete body.captcha;
    return this.axios.default().post(`${CONST.API_SAFEA_USERS}/operation/applications/${applicationAlias}/username/recover`, body, {
      headers: {
        'X-Aws-Waf-Token': captcha
      }
    });
  }

  recoverUsernameApplication(body, tenantAlias, applicationAlias) {
    const { captcha } = body;
    delete body.captcha;
    return this.axios.default().post(`${CONST.API_SAFEA_USERS}/tenants/${tenantAlias}/applications/${applicationAlias}/username/recover`, body, {
      headers: {
        'X-Aws-Waf-Token': captcha
      }
    });
  }

  /* =========== Reset Password =========== */
  resetPassword(body) {
    if (this.getters['_core/auth/isRoleOperation']) {
      return this.resetPasswordOperationApplication(body, this.state.application.alias);
    }

    return this.resetPasswordApplication(body, this.state.auth.currentRole?.tenant?.alias || this.state.tenant.alias, this.state.application.alias);
  }

  resetPasswordOperationApplication(body, applicationAlias) {
    const { captcha } = body;
    delete body.captcha;
    return this.axios.default().post(`${CONST.API_SAFEA_USERS}/operation/applications/${applicationAlias}/password/reset`, body, {
      headers: {
        'X-Aws-Waf-Token': captcha
      }
    });
  }

  resetPasswordApplication(body, tenantAlias, applicationAlias) {
    const { captcha } = body;
    delete body.captcha;
    return this.axios.default().post(`${CONST.API_SAFEA_USERS}/tenants/${tenantAlias}/applications/${applicationAlias}/password/reset`, body, {
      headers: {
        'X-Aws-Waf-Token': captcha
      }
    });
  }

  changeUserPassword(body) {
    return this.axios.withToken().put(`${CONST.API_SAFEA_USERS}/me/password`, body);
  }

  /* ====== Reset Password Confirmed ====== */
  resetPasswordConfirmed(body) {
    if (this.getters['_core/auth/isRoleOperation']) {
      return this.resetPasswordConfirmedOperation(body, this.state.application.alias);
    }

    return this.resetPasswordConfirmedApplication(body, this.state.tenant.alias || null, this.state.application.alias);
  }

  resetPasswordConfirmedOperation(body, applicationAlias) {
    const { captcha } = body;
    delete body.captcha;
    return this.axios.default().put(`${CONST.API_SAFEA_USERS}/operation/applications/${applicationAlias}/password/confirm`, body, {
      headers: {
        'X-Aws-Waf-Token': captcha
      }
    });
  }

  resetPasswordConfirmedApplication(body, tenantAlias, applicationAlias) {
    const { captcha } = body;
    delete body.captcha;
    return this.axios.default().put(`${CONST.API_SAFEA_USERS}/tenants/${tenantAlias}/applications/${applicationAlias}/password/confirm`, body, {
      headers: {
        'X-Aws-Waf-Token': captcha
      }
    });
  }

  /* ====== Check Reset Password Token ===== */
  resetPasswordCheckToken(token) {
    if (this.getters['_core/auth/isRoleOperation']) {
      return this.checkPasswordResetTokenOperationApplication(token, this.state.application.alias);
    }

    return this.checkPasswordResetTokenApplication(token, this.state.tenant.alias || null, this.state.application.alias);
  }

  checkPasswordResetTokenOperationApplication(token, applicationAlias) {
    return this.axios.default().get(`${CONST.API_SAFEA_USERS}/operation/applications/${applicationAlias}/password/reset/check/${token}`);
  }

  checkPasswordResetTokenApplication(token, tenantAlias, applicationAlias) {
    return this.axios.default().get(`${CONST.API_SAFEA_USERS}/tenants/${tenantAlias}/applications/${applicationAlias}/password/reset/check/${token}`);
  }

  /* ============== Sign up ============== */
  signUp(body, tenantAlias, iesAlias) {
    if (this.state.application.owner === 'tenant') {
      return this.signUpTenant(body, tenantAlias);
    } else {
      return this.signUpIes(body, tenantAlias, iesAlias);
    }
  }

  signUpTenant(body, tenantAlias) {
    const { captcha } = body;
    delete body.captcha;
    return this.axios.default().post(`${CONST.API_SAFEA_USERS}/tenants/${tenantAlias}?sendEmail=true`, body, {
      headers: {
        'X-Aws-Waf-Token': captcha
      }
    });
  }

  signUpIes(body, tenantAlias, iesAlias) {
    const { captcha } = body;
    delete body.captcha;
    return this.axios.default().post(`${CONST.API_SAFEA_USERS}/tenants/${tenantAlias}/ies/${iesAlias}?sendEmail=true`, body, {
      headers: {
        'X-Aws-Waf-Token': captcha
      }
    });
  }

  /* ================== Me =============== */
  updateUser(body) {
    return this.axios.withToken().patch(`${CONST.API_SAFEA_USERS}/me`, body);
  }

  updateUserPhoto(body) {
    return this.axios.withToken({
      'Accept'       : 'multipart/form-data',
      'Content-Type' : 'multipart/form-data'
    }).patch(`${CONST.API_SAFEA_USERS}/me/photo`, body);
  }

  getUserInfo() {
    return this.axios.withToken().get(`${CONST.API_SAFEA_USERS}/me`);
  }
}
